"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTable = require("react-table");

var _Button = require("../Button");

var _matchSorter = require("match-sorter");

var _withTheme = require("../../wrappers/with-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DefaultColumnFilter = function DefaultColumnFilter(_ref) {
  var column = _ref.column;
  var _column$filterValue = column.filterValue,
      filterValue = _column$filterValue === void 0 ? "" : _column$filterValue,
      setFilter = column.setFilter; // count = preFilteredRows.length;

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-3/4"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: theme.inputSmall,
    value: filterValue,
    onChange: function onChange(e) {
      return setFilter(e.target.value);
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    placeholder: "Search..."
  }));
};

function fuzzyTextFilterFn(rows, id, filterValue) {
  return (0, _matchSorter.matchSorter)(rows, filterValue, {
    keys: [function (row) {
      return row.values[id];
    }]
  });
}

var getPageSpread = function getPageSpread(page, maxPage) {
  var low = page - 2,
      high = page + 2;

  if (low < 0) {
    high += -low;
    low = 0;
  }

  if (high > maxPage) {
    low -= high - maxPage;
    high = maxPage;
  }

  var spread = [];

  for (var i = Math.max(0, low); i <= Math.min(maxPage, high); ++i) {
    spread.push(i);
  }

  return spread;
};

var DefaultExpandedRow = function DefaultExpandedRow(_ref2) {
  var values = _ref2.values;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, values.map(function (_ref3, i) {
    var key = _ref3.key,
        value = _ref3.value;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key || "key-".concat(i),
      className: "flex-1"
    }, key ? /*#__PURE__*/_react["default"].createElement("b", null, key, ":") : null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "ml-1"
    }, value));
  }));
};

var EMPTY_ARRAY = [];

var _default = function _default(_ref4) {
  var _ref4$columns = _ref4.columns,
      columns = _ref4$columns === void 0 ? EMPTY_ARRAY : _ref4$columns,
      _ref4$data = _ref4.data,
      data = _ref4$data === void 0 ? EMPTY_ARRAY : _ref4$data,
      sortBy = _ref4.sortBy,
      _ref4$sortOrder = _ref4.sortOrder,
      sortOrder = _ref4$sortOrder === void 0 ? "" : _ref4$sortOrder,
      _ref4$initialPageSize = _ref4.initialPageSize,
      initialPageSize = _ref4$initialPageSize === void 0 ? 10 : _ref4$initialPageSize,
      onRowClick = _ref4.onRowClick,
      _ref4$ExpandRow = _ref4.ExpandRow,
      ExpandRow = _ref4$ExpandRow === void 0 ? DefaultExpandedRow : _ref4$ExpandRow,
      _ref4$disableFilters = _ref4.disableFilters,
      disableFilters = _ref4$disableFilters === void 0 ? false : _ref4$disableFilters,
      _ref4$disableSortBy = _ref4.disableSortBy,
      disableSortBy = _ref4$disableSortBy === void 0 ? false : _ref4$disableSortBy,
      _ref4$customTheme = _ref4.customTheme,
      customTheme = _ref4$customTheme === void 0 ? {} : _ref4$customTheme,
      props = _objectWithoutProperties(_ref4, ["columns", "data", "sortBy", "sortOrder", "initialPageSize", "onRowClick", "ExpandRow", "disableFilters", "disableSortBy", "customTheme"]);

  var theme = _objectSpread(_objectSpread({}, (0, _withTheme.useTheme)()), customTheme);

  var filterTypes = _react["default"].useMemo(function () {
    return {
      fuzzyText: fuzzyTextFilterFn
    };
  }, []);

  var defaultColumn = _react["default"].useMemo(function () {
    return {
      Filter: DefaultColumnFilter
    };
  }, []);

  var _useTable = (0, _reactTable.useTable)({
    columns: columns,
    data: data,
    defaultColumn: defaultColumn,
    filterTypes: filterTypes,
    disableFilters: disableFilters,
    disableSortBy: disableSortBy,
    initialState: {
      pageSize: initialPageSize,
      sortBy: [{
        id: sortBy,
        desc: sortOrder.toLowerCase() === "desc"
      }]
    }
  }, _reactTable.useFilters, _reactTable.useGlobalFilter, _reactTable.useSortBy, _reactTable.useExpanded, _reactTable.usePagination),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      page = _useTable.page,
      rows = _useTable.rows,
      preFilteredRows = _useTable.preFilteredRows,
      prepareRow = _useTable.prepareRow,
      canPreviousPage = _useTable.canPreviousPage,
      canNextPage = _useTable.canNextPage,
      gotoPage = _useTable.gotoPage,
      previousPage = _useTable.previousPage,
      nextPage = _useTable.nextPage,
      pageCount = _useTable.pageCount,
      visibleColumns = _useTable.visibleColumns,
      toggleRowExpanded = _useTable.toggleRowExpanded,
      _useTable$state = _useTable.state,
      pageSize = _useTable$state.pageSize,
      pageIndex = _useTable$state.pageIndex,
      expanded = _useTable$state.expanded;

  if (!(columns.length && data.length)) return null;
  if (!preFilteredRows.length) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-auto scrollbar-sm"
  }, /*#__PURE__*/_react["default"].createElement("table", _extends({}, getTableProps(), {
    className: "w-full"
  }), /*#__PURE__*/_react["default"].createElement("thead", null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/_react["default"].createElement("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      return /*#__PURE__*/_react["default"].createElement("th", _extends({}, column.getHeaderProps(column.getSortByToggleProps()), {
        className: theme.tableHeader
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-1"
      }, column.render("Header")), !column.isSorted ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-0 mr-8"
      }, column.isSortedDesc ? /*#__PURE__*/_react["default"].createElement("i", {
        className: "ml-2 pt-1 fas fa-chevron-down"
      }) : /*#__PURE__*/_react["default"].createElement("i", {
        className: "ml-2 pt-1 fas fa-chevron-up"
      }))), !column.canFilter ? null : /*#__PURE__*/_react["default"].createElement("div", null, column.render('Filter')));
    }));
  }), pageCount <= 1 ? null : /*#__PURE__*/_react["default"].createElement("tr", {
    className: theme.tableInfoBar
  }, /*#__PURE__*/_react["default"].createElement("td", {
    colSpan: columns.length,
    className: "px-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center ".concat(theme.textInfo)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-0"
  }, "Page ", pageIndex + 1, " of ", pageCount, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-extrabold"
  }, "\xA0 | \xA0"), "Rows ", pageIndex * pageSize + 1, "-", Math.min(rows.length, pageIndex * pageSize + pageSize), " of ", rows.length), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex justify-end items-center"
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    disabled: pageIndex === 0,
    buttonTheme: "textbuttonInfoSmall",
    onClick: function onClick(e) {
      return gotoPage(0);
    }
  }, "<<"), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    disabled: !canPreviousPage,
    buttonTheme: "textbuttonInfoSmall",
    onClick: function onClick(e) {
      return previousPage();
    }
  }, "<"), getPageSpread(pageIndex, pageCount - 1).map(function (p) {
    var active = p === pageIndex;
    return /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      key: p,
      buttonTheme: "textbuttonInfo",
      active: active,
      large: active,
      small: !active,
      onClick: active ? null : function (e) {
        return gotoPage(p);
      }
    }, p + 1);
  }), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    disabled: !canNextPage,
    buttonTheme: "textbuttonInfoSmall",
    onClick: function onClick(e) {
      return nextPage(0);
    }
  }, ">"), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    disabled: pageIndex === pageCount - 1,
    buttonTheme: "textbuttonInfoSmall",
    onClick: function onClick(e) {
      return gotoPage(pageCount - 1);
    }
  }, ">>")))))), /*#__PURE__*/_react["default"].createElement("tbody", getTableBodyProps(), page.map(function (row) {
    var _row$original = row.original,
        _onClick = _row$original.onClick,
        _row$original$expand = _row$original.expand,
        expand = _row$original$expand === void 0 ? [] : _row$original$expand;
    prepareRow(row);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: row.getRowProps().key
    }, /*#__PURE__*/_react["default"].createElement("tr", _extends({}, row.getRowProps(), {
      className: "\n                        ".concat(props.striped ? theme.tableRowStriped : theme.tableRow, "\n                        ").concat(_onClick || onRowClick ? "cursor-pointer" : "", "\n                      "),
      onClick: function onClick(e) {
        typeof onRowClick === "function" && onRowClick(e, row);
        typeof _onClick === "function" && _onClick(e, row);
      }
    }), row.cells.map(function (cell, ii) {
      return /*#__PURE__*/_react["default"].createElement("td", _extends({}, cell.getCellProps(), {
        className: theme.tableCell
      }), ii > 0 || row.subRows.length === 0 && expand.length === 0 ? cell.render('Cell') : /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-1"
      }, cell.render('Cell')), /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();
          Object.keys(expanded).filter(function (k) {
            return k !== row.id;
          }).forEach(toggleRowExpanded);
          row.toggleRowExpanded(!row.isExpanded);
        },
        className: "\n                                        flex item-center justify-center\n                                        rounded cursor-pointer py-1 px-2\n                                        hover:".concat(theme.accent3, " ").concat(theme.transition, "\n                                      ")
      }, row.isExpanded ? /*#__PURE__*/_react["default"].createElement("i", {
        className: "fas fa-chevron-up"
      }) : /*#__PURE__*/_react["default"].createElement("i", {
        className: "fas fa-chevron-down"
      }))));
    })), !row.isExpanded || !expand.length ? null : /*#__PURE__*/_react["default"].createElement("tr", {
      className: theme.tableRow
    }, /*#__PURE__*/_react["default"].createElement("td", {
      colSpan: visibleColumns.length,
      className: theme.tableCell
    }, /*#__PURE__*/_react["default"].createElement(ExpandRow, {
      values: expand
    }))));
  }))));
};

exports["default"] = _default;